import { createAsyncThunk } from "@reduxjs/toolkit";
import luckyDrawV2Api from "app/api/luckyDrawV2";

const LUCKY_DRAW_V2 = "luckyDrawV2";

// Fetch claim list (To Process tab)
export const fetchClaimList = createAsyncThunk(
  `${LUCKY_DRAW_V2}/fetchClaimList`,
  async (payload, thunkApi) => {
    return luckyDrawV2Api
      .getClaimList(payload)
      .then((response) => response.data)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);

// Fetch unclaim list (Unclaimed Prize tab)
export const fetchUnclaimList = createAsyncThunk(
  `${LUCKY_DRAW_V2}/fetchUnclaimList`,
  async (payload, thunkApi) => {
    return luckyDrawV2Api
      .getUnclaimList(payload)
      .then((response) => response.data)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);

// Fetch lucky draw details
export const fetchLuckyDrawDetails = createAsyncThunk(
  `${LUCKY_DRAW_V2}/fetchLuckyDrawDetails`,
  async (uuid, thunkApi) => {
    return luckyDrawV2Api
      .getLuckyDrawDetails(uuid)
      .then((response) => response.data)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);

// Update winner claim fulfillment status
export const updateWinnerClaimFulfillmentStatus = createAsyncThunk(
  `${LUCKY_DRAW_V2}/updateWinnerClaimFulfillmentStatus`,
  async (payload, thunkApi) => {
    return luckyDrawV2Api
      .updateWinnerClaimFulfillmentStatus(payload)
      .then((response) => response.data)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);

// Update admin notes
export const updateAdminNotes = createAsyncThunk(
  `${LUCKY_DRAW_V2}/updateAdminNotes`,
  async (payload, thunkApi) => {
    return luckyDrawV2Api
      .updateAdminNotes(payload)
      .then((response) => response.data)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);

// Export claim list
export const exportClaimList = createAsyncThunk(
  `${LUCKY_DRAW_V2}/exportClaimList`,
  async (payload, thunkApi) => {
    const state = thunkApi.getState();
    const accessToken = state.session.accessToken;
    const timezone = state.profile.timezone;

    return luckyDrawV2Api
      .exportClaimList({
        ...payload,
        token: accessToken,
        timezone: timezone || "Asia/Kuala_Lumpur",
      })
      .then((response) => response)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);

// Fetch claim summary for metrics (uses dedicated API endpoint)
export const fetchClaimSummary = createAsyncThunk(
  `${LUCKY_DRAW_V2}/fetchClaimSummary`,
  async (uuid, thunkApi) => {
    return luckyDrawV2Api
      .getClaimSummary({ luckyDrawUuid: uuid })
      .then((response) => response.data)
      .catch((error) => thunkApi.rejectWithValue(error));
  }
);

// Fetch all winners for metrics calculation (legacy - kept for backward compatibility)
export const fetchAllWinnersForMetrics = createAsyncThunk(
  `${LUCKY_DRAW_V2}/fetchAllWinnersForMetrics`,
  async (uuid, thunkApi) => {
    try {
      const [claimListResponse, unclaimListResponse] = await Promise.all([
        luckyDrawV2Api.getClaimList({
          luckyDrawUuid: uuid,
          limit: 10000,
          skip: 0,
        }),
        luckyDrawV2Api.getUnclaimList({
          luckyDrawUuid: uuid,
          limit: 10000,
          skip: 0,
        }),
      ]);

      const claimedWinners = claimListResponse.data?.claims || [];
      const unclaimedWinners = unclaimListResponse.data?.claims || [];

      return {
        claimedWinners,
        unclaimedWinners,
      };
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);
